export default __webpack_public_path__ + "static/do-focus-at-start-4d93ce3d2b8367b198041557da67c961.png";